import { useRouter } from 'next/router';
import { useSnapshot } from 'valtio/react';

import { Button } from '@paid-ui/components/button';

import { signUpManager } from '../../models';
import { SignUpStep } from '../../models/enums';

interface Props {
  disabled?: boolean;
}

export const StepSignContract: React.FC<Props> = ({ disabled }) => {
  const router = useRouter();
  const { currentStep } = useSnapshot(signUpManager);

  if (currentStep !== SignUpStep.SIGN_CONTRACT) {
    return null;
  }

  const handleClick = () => {
    const urlSearchParams = new URLSearchParams(globalThis.location.search);
    const dialog = urlSearchParams.get('dialog') || 'sign-contract';
    const projectId = urlSearchParams.get('projectId');

    urlSearchParams.delete('step');
    urlSearchParams.delete('partyId');
    urlSearchParams.delete('email');
    urlSearchParams.delete('token');
    urlSearchParams.delete('projectId');
    urlSearchParams.delete('contractType');
    urlSearchParams.set('dialog', dialog);
    urlSearchParams.sort();

    router.push({
      pathname: projectId ? `/projects/${projectId}` : '/',
      search: urlSearchParams.toString(),
    });
  };

  return (
    <div className="space-y-9">
      <Button size="xl" variant="solid" disabled={disabled} onClick={handleClick}>
        Sign contract
      </Button>
    </div>
  );
};
